module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }